<template>
  <div id="device-page">
    <div class="header">
      <div class="add-box">
        <!-- <el-button type="text" @click="downloadFile">下载模板</el-button> -->
        <el-upload
          class="upload-demo"
          action="/rest/importEquipInfo"
          accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :show-file-list="false"
          :disabled="exportLoading"
          :before-upload="handleBeforeUpload"
          :on-success="handleFileSuccess"
          :on-error="handleFileError">
          <el-button type="primary" v-loading="exportLoading">导入数据</el-button>
        </el-upload>
          <!-- :limit="1" -->
        <el-button type="primary" @click="handleClickAdd">新增</el-button>
      </div>
    </div>
    <!-- 查询条件 -->
    <div class="query">
      <div class="user-management-input">
        <div class="flex-item">
          <span class="query-text">设备状态：</span>
          <base-select
            v-model="selectQuery.status"
            color="blue"
            placeholder="请选择"
          >
            <el-option
              v-for="item in statusOption"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </base-select>
        </div>
        <div class="flex-item">
          <span class="query-text">设备类型：</span>
          <base-select
            v-model="selectQuery.equipType"
            color="blue"
            placeholder="请选择"
          >
            <el-option
              v-for="item in typeOption"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            />
          </base-select>
        </div>
        <div class="flex-item">
          <span class="query-text">设备区域：</span>
          <base-select
            v-model="selectQuery.region"
            color="blue"
            placeholder="请选择"
          >
            <el-option
              v-for="item in areaOption"
              :key="item.regionCode"
              :label="item.regionName"
              :value="item.regionCode"
            />
          </base-select>
        </div>
      </div>
      <base-button color="blue" @click='handleSearch' v-loading="tableLoading">
        查询
      </base-button>
    </div>

    <div class='contain-box'>
      <base-table class="table-box" :data="list" v-loading="tableLoading">
        <el-table-column
          prop="code"
          label="设备编码"
          show-overflow-tooltip
          :resizable="false"
          align='center'
        />
        <el-table-column
          prop="equipType"
          label="设备类型"
          width="140"
          show-overflow-tooltip
          :resizable="false"
          align='center'
        />
        <el-table-column
          prop="createTime"
          label="创建时间"
          show-overflow-tooltip
          :resizable="false"
          align='center'
        />
        <el-table-column
          prop="regionName"
          label="所属区域"
          width="140"
          show-overflow-tooltip
          :resizable="false"
          align='center'
        />
        <el-table-column
          prop="position"
          label="设备位置"
          width="140"
          show-overflow-tooltip
          :resizable="false"
          align='center'
        />
        <el-table-column
          label="状态"
          :resizable="false"
          width="200px"
          align='center'>
          <template slot-scope="scope">
            <div class="status-box" :style="{color: scope.row.color}">
              <p>{{scope.row.statusName}}</p>
              <p class="time">{{scope.row.time}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" :resizable="false">
          <template slot-scope="scope">
            <base-button type="text" color="blue" @click="handleEdit(scope.row)">
              编辑
            </base-button>
            <base-button type="text" color="red" @click="handleDelete(scope.row)">
              删除
            </base-button>
            <base-button type="text" color="blue" @click="handleHistory(scope.row)">
              设备记录
            </base-button>
            <base-button type="text" color="blue" @click="handleClick(scope.row, '保养')" v-if="scope.row.statusName=='待保养'">
              保养
            </base-button>
            <base-button type="text" color="red" @click="handleClick(scope.row, '报废')" v-if="scope.row.statusName=='待报废' || scope.row.statusName=='逾期报废'">
              报废
            </base-button>
          </template>
        </el-table-column>
      </base-table>

      <base-pagination
        v-show="pagination.total > 0"
        :total="pagination.total"
        :current-page.sync="pagination.pageIndex"
        :page-size.sync="pagination.pageSize"
        @pagination="setPagination"
      />
    </div>

    <!-- 新增（编辑）弹窗 -->
    <base-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="edit-dialog"
      dialogSize="normal">
      <div class="dialog-content">
        <div class="dialog-item">
          <p><span>*</span>设备编号：</p>
          <base-input
            :isTitle="false"
            v-model="addTableList.code"
            width="100%"
          />
        </div>
        <div class="dialog-item">
          <p><span>*</span>设备类型：</p>
          <base-select v-model="addTableList.equipType" color="blue">
            <el-option
              v-for="item in typeOption"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            />
          </base-select>
        </div>
        <div class="dialog-item">
          <p><span>*</span>所属区域：</p>
          <base-select v-model="addTableList.regionId" color="blue">
            <el-option
              v-for="item in areaOption"
              :key="item.regionCode"
              :label="item.regionName"
              :value="item.regionCode"
            />
          </base-select>
        </div>
        <div class="dialog-item position-item">
          <p><span>*</span>设备位置：</p>
          <base-input
            :isTitle="false"
            v-model="addTableList.position"
            width="100%"
          />
        </div>
        <div class="dialog-item">
          <p><span>*</span>近期保养(充粉、二氧化碳)时间：</p>
          <el-date-picker
            v-model="addTableList.maintenanceTime"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期">
          </el-date-picker>
        </div>
        <div class="dialog-item">
          <p><span>*</span>保养周期(单位：月)：</p>
          <el-input-number v-model="addTableList.maintenancePeriod" :precision="0" :min="1"></el-input-number>
        </div>
        <div class="dialog-item">
          <p><span>*</span>报废截止时间：</p>
          <el-date-picker
            v-model="addTableList.expirationTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <base-button
          color="blue"
          @click="() => (dialogVisible = false)"
        >
          取 消
        </base-button>
        <base-button
          color="blue"
          bg-color
          v-loading="addLoading"
          @click="handleAddTable"
        >
          确 定
        </base-button>
      </span>
    </base-dialog>

    <!-- 保养（报废）弹窗 -->
    <base-dialog
      :title="maintainOrScrap.dialogTitle"
      :visible.sync="dialogVisible2"
      dialogSize="small">
      <div class="dialog-content2">
        <div class="dialog-item">
          <p class="title">{{maintainOrScrap.dialogTitle}}设备：</p>
          <p class="code-box">{{maintainOrScrap.code}}</p>
        </div>
        <div class="dialog-item">
          <p class="title">上次保养时间：</p>
          <p class="time-box">{{maintainOrScrap.lastMaintenanceTime}}</p>
        </div>
        <div class="dialog-item">
          <p class="title"><span>*</span>请输入本次{{maintainOrScrap.dialogTitle}}时间：</p>
          <el-date-picker
            v-model="maintainOrScrap.maintenanceTime"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            :clearable="false"
            placeholder="选择日期">
          </el-date-picker>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <base-button
          color="blue"
          @click="() => (dialogVisible2 = false)"
        >
          取 消
        </base-button>
        <base-button
          color="blue"
          bg-color
          v-loading="addLoading"
          @click="handleAddTable"
        >
          确 定
        </base-button>
      </span>
    </base-dialog>

    <!-- 设备记录列表start -->
    <el-drawer
      :title="`设备记录(${equipCode})`"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="done => done()"
    >
      <div class='current-box'>
        <el-table :data="operateList">
          <el-table-column property="modifyTime" label="操作时间"  align="center" minWidth="110"></el-table-column>
          <el-table-column property="operator" label="操作人"  align="center"></el-table-column>
          <el-table-column property="operaterName" label="操作后状态"  align="center"></el-table-column>
        </el-table>
        <base-pagination
          layout="prev, pager, next"
          v-show="operate.total > 0"
          :total="operate.total"
          :current-page.sync="operate.pageIndex"
          :page-size.sync="operate.pageSize"
          @pagination="setOperatePage"
        />
      </div>
    </el-drawer>
    <!-- 设备记录列表end -->
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton'
import BaseSelect from '@/components/BaseSelect'
import BasePagination from '@/components/BasePagination'
import BaseTable from '@/components/BaseTable'
import BaseDialog from '@/components/BaseDialog'
import BaseInput from '@/components/BaseInput'
import { getList, saveData, getDic, getEquipOperaterInfos, deleteData, editSaveData } from './service.js'
import { formatDateTime } from '@/utils/objectUtil.js'

export default {
  name: 'DevicePage',
  components: {
    BaseButton,
    BaseSelect,
    BasePagination,
    BaseTable,
    BaseDialog,
    BaseInput,
  },
  data () {
    return {
      typeOption: [],
      areaOption: [],
      statusOption: [],
      selectQuery: {
        status: '',
        equipType: '',
        region: '',
      },
      tableLoading: false,
      addLoading: false,
      exportLoading: false,
      dialogVisible: false,
      dialogVisible2: false,
      drawer: false,
      list: [],
      pagination: { total: 0, pageIndex: 1, pageSize: 10 },
      operate: { total: 0, pageIndex: 1, pageSize: 10 },
      dialogTitle: '新增',
      addTableList: {
        code: '',
        equipType: '',
        regionId: '',
        position: '',
        maintenanceTime: '',
        maintenancePeriod: '',
        expirationTime: '',
      },
      isEdit: false,
      maintainOrScrap: {
        dialogTitle: '保养',
        code: '',
        lastMaintenanceTime: '',
        maintenanceTime: formatDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss'),
      },
      operateList: [],
      equipCode: '',
    }
  },
  created () {
    this.initSelectOption()
  },
  mounted () {
    let params = this.$route.params
    Object.assign(this.selectQuery, params)
    this.getList({ pageIndex: 1, pageSize: 10, ...params })
  },
  methods: {
    // 查询按钮
    handleSearch () {
      this.pagination.pageIndex = 1
      let { pagination: { pageSize }, selectQuery: { status, equipType, region } } = this
      this.getList({ status, equipType, region, pageIndex: 1, pageSize })
    },
    // 删除数据
    handleDelete (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteData({ id: row.id }).then(() => {
          this.handleSearch()
        }).finally(() => (this.tableLoading = false))
      })
    },
    /**
     * @description: 切换页数
     * @param        {number} e [点击页数]
     */
    setPagination (e) {
      this.pagination.pageIndex = e
      let { pagination: { pageSize }, selectQuery: { status, equipType, region } } = this
      this.getList({ status, equipType, region, pageIndex: e, pageSize })
    },
    /**
     * @description: 切换页数-操作记录
     * @param        {number} e [点击页数]
     */
    setOperatePage (e) {
      this.operate.pageIndex = e

      let { operate: { pageSize } } = this

      let params = { pageIndex: e, pageSize: 10, equipCode: this.equipCode }

      this.getOperateList(params)
    },
    editSaveData (params) {
      editSaveData(params).then(res => {
        if (res.code === 'success') {
          this.dialogVisible = false
          this.handleSearch()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /**
     * @description: 新增、编辑确认按钮
     */
    async handleAddTable () {
      let params = {
        ...this.addTableList,
      }

      for (let k in params) {
        if (k !== 'actualScrapTime' && !params[k]) {
          this.$message({ message: '*号为必填项，请填写', type: 'warning' })
          return
        }
      }

      // 代表为编辑操作
      if (this.isEdit) {
        this.editSaveData(params)
        return
      }

      this.addLoading = true
      let res = await saveData(params)
      this.addLoading = false
      this.isEdit = false
      if (res.code === 'success') {
        this.dialogVisible = false
        this.dialogVisible2 = false
        this.$message({ message: res.msg, type: 'success' })
        let { pagination: { pageIndex, pageSize } } = this
        this.getList({ pageIndex, pageSize })
      } else {
        this.$message.error(res.msg)
      }
    },
    /**
     * @description: 点击新增按钮
     */
    handleClickAdd () {
      this.addTableList = {
        code: '',
        equipType: this.typeOption.length ? this.typeOption[0].name : '',
        regionId: this.areaOption.length ? this.areaOption[0].regionCode : '',
        position: '',
        maintenanceTime: '',
        maintenancePeriod: '',
        expirationTime: '',
        // status: '0',
      }
      this.isEdit = false
      this.dialogVisible = true
      this.dialogTitle = '新增'
    },
    // 下载文件
    downloadFile () {
      window.open('/rest/downLoadFile', '_blank')
    },
    // 上传文件个数大于限制数时的钩子
    // handleExceed(files, fileList) {
    //   this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件！`)
    // },
    // 上传之前的钩子
    handleBeforeUpload (files, fileList) {
      this.exportLoading = true
    },
    // 上传文件成功时的钩子
    handleFileSuccess (res) {
      this.exportLoading = false
      let { respCode, respList, respMessage } = res

      if (respCode === 'success') {
        this.$message({ message: respMessage, type: 'success' })
        let { selectQuery: { status, equipType, region } } = this
        this.getList({ status, equipType, region, pageIndex: 1, pageSize: 10 })
      } else {
        if (respList && respList.length) {
          let list = respList.join()
          this.$notify({
            title: '警告',
            message: `${respMessage}，设备编号：${list}`,
            type: 'warning',
            duration: 0,
          })
        } else {
          this.$message.error({ message: respMessage })
        }
      }
    },
    // 上传文件失败时的钩子
    handleFileError (files, fileList) {
      this.exportLoading = false
      this.$message.error('上传失败')
    },
    // 操作记录
    handleHistory ({ code }) {
      this.drawer = true
      this.equipCode = code
      let params = { pageIndex: 1, pageSize: 10, equipCode: code }

      this.getOperateList(params)
    },
    // 点击详情
    handleEdit (row) {
      this.isEdit = true
      this.dialogVisible = true
      this.dialogTitle = '编辑'
      let { code, equipType, regionId, position, maintenanceTime, maintenancePeriod, expirationTime, id, status } = row

      Object.assign(this.addTableList, { code, equipType, regionId, position, maintenanceTime, maintenancePeriod, expirationTime, id, status })
    },
    // 请求列表数据
    async getList (params) {
      this.tableLoading = true

      let res = await getList(params)
      this.tableLoading = false
      if (res.code === 'success') {
        this.list = res.data.list.map(item => {
          // 区域code转name
          let option = this.areaOption.find(({ regionCode }) => regionCode === item.regionId)
          // 处理上次保养时间-后端格式不对
          let maintenanceTime = item.maintenanceTime ? item.maintenanceTime.split(' ')[0] : ''
          // 处理截至日期(保养截至日期（上次保养时间 + 保养周期）)-后端格式不对
          let expirationmaintenanceTime = item.maintenanceTime ? this.setTime(item.maintenanceTime, item.maintenancePeriod) : ''
          // 处理截至日期(报废截至日期)-后端格式不对
          let expirationTime = item.expirationTime ? item.expirationTime.split(' ')[0] : ''
          // 处理实际报废日期-后端格式不对
          let actualScrapTime = item.actualScrapTime ? item.actualScrapTime.split(' ')[0] : ''
          // 为减少代码量写的temp对象
          let tempArr = [
            { code: '0', title: '上次保养：', key: maintenanceTime },
            { code: '1', title: '截止日期：', key: expirationmaintenanceTime },
            { code: '2', title: '截止日期：', key: expirationTime },
            { code: '3', title: '报废日期：', key: actualScrapTime },
            { code: '4', title: '截止日期：', key: expirationTime },
          ]
          // 展示状态下的文案及日期 - 可以看阿里云校的原型
          item.time = tempArr[item.status] ? (tempArr[item.status].title + tempArr[item.status].key) : ''

          item.color = item.status === '0' ? '#3890f2' : item.status === '3' ? '#aaa' : 'red'

          item.statusName = this.statusOption[item.status] && this.statusOption[item.status].name

          item.regionName = option && option.regionName

          return item
        })
        this.pagination.total = res.data.total
      }
    },
    // 初始化下拉框数据
    async initSelectOption () {
      let areaOption = this.$store.state.userRegions
      this.areaOption = areaOption

      let statusOption = await getDic('getEquipStatus')
      if (statusOption.code === 'success') this.statusOption = statusOption.data.list

      let typeOption = await getDic('getEquipType')
      if (typeOption.code === 'success') this.typeOption = typeOption.data.list
    },
    // 保养或者报废
    handleClick (row, type) {
      let { code, equipType, regionId, position, maintenanceTime, maintenancePeriod, expirationTime, id, status } = row
      this.dialogVisible2 = true

      let lastMaintenanceTime = maintenanceTime ? maintenanceTime.split(' ')[0] : ''

      Object.assign(this.maintainOrScrap, { dialogTitle: type, code, lastMaintenanceTime })

      let submitTime = {}
      if (type === '保养') {
        submitTime = {
          maintenanceTime: this.maintainOrScrap.maintenanceTime,
          actualScrapTime: '',
        }
      } else {
        submitTime = {
          maintenanceTime,
          actualScrapTime: this.maintainOrScrap.maintenanceTime,
        }
      }

      Object.assign(this.addTableList, {
        code,
        equipType,
        regionId,
        position,
        maintenancePeriod,
        expirationTime,
        id,
        // status: type == '保养' ? '0' : '3',
      }, submitTime)
    },
    // 计算保养截至时间
    setTime (time, period) {
      let MonthDay = new Date(new Date(time).getFullYear(), (new Date(time).getMonth() + 1), 0).getDate()
      let periodTime = period * MonthDay * 24 * 60 * 60 * 1000
      let date = new Date(time).getTime() + periodTime
      let result = formatDateTime(new Date(date), 'yyyy-MM-dd HH:mm:ss')
      return result.split(' ')[0]
    },
    // 请求操作记录列表
    async getOperateList (params) {
      let res = await getEquipOperaterInfos(params)
      if (res.code === 'success') {
        let { total, list } = res.data
        this.operate.total = total

        this.operateList = list.map(res => {
          // let option = this.statusOption.find(({ code }) => code === res.operaterStatus)
          let temp = {
            '0': '保养',
            '3': '报废',
          }

          res.operaterName = temp[res.operaterStatus] || ''
          return res
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/static/style/common';
#device-page {
  .header {
    // padding: 20px 1%;
    height: 70px;
    line-height: 70px;
    // margin-bottom: 10px;
    // .radio-box {
    //   display: inline-block;
    // }
    border: 1px solid transparent;
    box-sizing: border-box;
    .add-box {
      float: right;
      margin-right: 30px;
      .upload-demo {
        display: inline-block;
        margin-right: 20px;
        margin-left: 20px;
      }
    }
  }
  .query {
    // height: 36px;
    padding: 20px 0;
    background: #fff;
    border-radius: 3px;
    width: 98%;
    margin: 0 auto;
    .el-button {
      float: right;
      margin-right: 15px;
    }
    .user-management-input {
      margin-left: 15px;
      display: inline-block;
      .flex-item {
        display: inline-block;
        width: 300px;
        .query-text {
          display: inline-block;
          font-size: @ec-font-size-main;
          color: @ec-color-text-main;
          font-size: 14px;
        }
      }
      /deep/ .el-input {
        width: 200px;
      }
    }
  }
  .contain-box {
    width: 98%;
    margin: 0 auto;
    background-color: #fff;
    .table-list-pages{
      margin-top: 35px;
      text-align: center;
      /deep/ .el-pager li{
        background-color: transparent;
        color: #333;
        width: 34px;
        height: 34px;
        line-height: 34px;
        &.number{
          border: 1px solid #666;
        }
      }
      /deep/ .el-pagination.is-background .btn-next, /deep/ .el-pagination.is-background .btn-prev{
        width: 34px;
        height: 34px;
      }
    }
    .status-box {
      margin-top: 8px;
      line-height: 20px;
      >p {
        height: 20px;
        &.time {
          font-size: 12px;
        }
      }
    }
  }

  /deep/.edit-dialog{
    .base-dialog{
      height: 500px
    }
  }
  .dialog-content {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 50%);
    // border: 1px solid blue;
    .dialog-item {
      margin-bottom: 25px;
      > p {
        margin-bottom: 15px;
        >span {
          color: red;
        }
      }
      #base-input, .base-select{
        width: 90%;
      }
    }
    .position-item {
      width: 100%;
      #base-input, .base-select{
        width: 96%;
      }
    }
  }
  .dialog-content2 {
    width: 72%;
    margin: 20px auto;
    // border: 1px solid red;
    .dialog-item {
      height: 40px;
      > p {
        display: inline-block;
        color: #333;
        &.title {
          width: 150px;
          text-align: right;
          color: #333;
        }
        &.code-box {
          font-size: 16px;
          font-weight: bold;
          color: #3890f2;
        }
        &.time-box {
          font-size: 16px;
          font-weight: bold;
        }
        >span {
          color: red;
        }
      }
    }
  }
  /deep/ :focus {
    outline: 0;
  }
  /deep/ .el-drawer {
    min-width: 390px;
  }
}
</style>
